import { render, staticRenderFns } from "./GradeIdSelectbox.vue?vue&type=template&id=5ef89b6d&"
import script from "./GradeIdSelectbox.vue?vue&type=script&lang=js&"
export * from "./GradeIdSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports